import React, { useEffect, useState, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getUserError, getUserStatus } from '../store/slices/userSlice';
import $ from "jquery"
import 'datatables.net'
import Modal from 'react-modal';
import { deleteAnnouncement, deleteFished, getAllAnnouncements, sendAnnouncement } from '../store/featureActions';
import ImageViewer from "react-simple-image-viewer";
import toast from 'react-hot-toast';
const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: "30%",
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        border: "0px",
        padding: "0px",
    },
};
Modal.setAppElement('#root');
const Announcements = () => {
    const [id, setId] = useState()
    const dispatch = useDispatch()
    const status = useSelector(getUserStatus)
    const error = useSelector(getUserError)
    const [announcementListing, setAnnouncementListing] = useState(null)
    const [detail, setDetail] = useState(null)
    const [modalIsOpen, setIsOpen] = useState(false);
    const [modalType, setModalType] = useState()
    const [title, setTitle] = useState("")
    const [description, setDescription] = useState("")
    const [files, setFiles] = useState([])
    const [modalImages, setmodalImages] = useState(false);
    const [currentImage, setCurrentImage] = useState(0);


    const openImageViewer = useCallback((images, index) => {
        setCurrentImage(index);
        setmodalImages(images);
    }, []);

    function viewModal(item, type) {
        if (type == "detail") {
            setDetail(item)
        } else if (type == "create") {
            setId(item)
        } else if (type == "edit") {
            setDetail(item)
            setId(item?._id)
        } else if (type == "delete") {
            setId(item)
        }
        setModalType(type)
        setIsOpen(true);
    }
    function closeModal() {
        setIsOpen(false);
        setTitle("")
        setDescription("")
        setFiles([])
        setCurrentImage(0);
        setmodalImages(false);
    }

    const announcementDelete = async (id) => {
        try {
            let payload = {
                params: id,
                isToast: true
            }
            await dispatch(deleteAnnouncement(payload)).unwrap()
            setIsOpen(false)
            $('#tableData')
                .DataTable().destroy();
            try {
                allAnnouncements()
            } catch (rejectedValueOrSerializedError) {
                console.log(rejectedValueOrSerializedError)
            }
        } catch (rejectedValueOrSerializedError) {
            console.log(rejectedValueOrSerializedError)
        }
    }

    const allAnnouncements = async () => {
        try {
            setAnnouncementListing(null)
            let payload = {
                params: false,
                isToast: false
            }
            const response = await dispatch(getAllAnnouncements(payload)).unwrap()
            setAnnouncementListing(response?.data?.announcements)
        } catch (rejectedValueOrSerializedError) {
            console.log(rejectedValueOrSerializedError)
        }
    }

    const accouncementSend = async (e) => {
        e.preventDefault()
        let formData = new FormData()
        try {
            if (title?.trim()?.length < 1) {
                toast.error("Title field can't be empty")
            } else if (description?.trim()?.length < 1) {
                toast.error("Description field can't be empty")
            } else {
                formData.append("title", title)
                formData.append("description", description)
                for (const image of files) {
                    formData.append("announcements", image);
                }
                let payload = {
                    body: formData,
                    params: false,
                    isToast: true
                }
                await dispatch(sendAnnouncement(payload)).unwrap()
                closeModal()
                if (announcementListing) {
                    $('#tableData')
                        .DataTable().destroy();
                }
                allAnnouncements()
            }
        } catch (rejectedValueOrSerializedError) {
            console.log(rejectedValueOrSerializedError)
        }
    }

    useEffect(() => {
        let mount = true
        if (mount) {
            allAnnouncements();
        }
        return () => {
            mount = false
        }
    }, [])
    useEffect(() => {
        if (announcementListing) {
            $('#tableData')
                .DataTable({
                    lengthMenu: [10, 25, 50, 100, 200],
                    language: {
                        "emptyTable": "Announcement List Not Found"
                    },
                    destroy: true,
                });
        }
    }, [announcementListing])
    return (
        <>
            <Modal
                closeTimeoutMS={500}
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                style={customStyles}
                contentLabel="Change Password"
            >
                <div className='change-password-modal' id="exampleModalCenter" tabIndex={-1} aria-labelledby="exampleModalCenterTitle" aria-hidden="true" style={{ display: "block", zIndex: 100 }}>
                    {modalType == "detail" ? <>
                        <div className="headerModal">
                            <p className="pass-text">Detail</p>
                            <button onClick={closeModal} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body">
                            <p > <b>Title:</b> {detail?.title ? detail?.title : <>No Title Found</>} </p>
                            <p > <b>Description:</b> {detail?.description ? detail?.description : <>No Description Found</>} </p>
                            <p > <b>Files:</b>
                                <div className='mt-1'>
                                    {
                                        detail?.files?.length > 0 ? detail?.files?.map((item, i) => (
                                            <img key={i} height="20%" width="20%" style={{ borderRadius: 5, marginRight: 10 }} src={item} onClick={() => openImageViewer(detail?.files, i)} />
                                        )) : <>No Files Found</>
                                    }
                                </div> </p>

                        </div>
                    </> : modalType == "create" ? <>
                        <div className="headerModal">
                            <p className="pass-text">Send Announcement</p>
                            <button onClick={closeModal} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body">
                            <div className="input-group input-group-sm mb-3 w-100">
                                <input type="text" maxLength={25} className="form-control" placeholder='Enter Title' aria-label="Title" value={title} onChange={(e) => setTitle(e.target.value)} />
                            </div>
                            <div className="input-group input-group-sm mb-3 w-100">
                                <textarea maxLength={275} className="form-control text-area-class2" placeholder='Enter Description' aria-label="Description" value={description} onChange={(e) => setDescription(e.target.value)} />
                            </div>
                            <div className="input-group input-group-sm mb-3 w-100">
                                <input type='file' multiple onChange={(e) => setFiles(e.target?.files)} />
                            </div>
                            <button className="excel-btn col-reds w-10 pt-2 pb-2" style={{ backgroundColor: "#0077DC" }} type="submit" onClick={accouncementSend}>Send</button>
                        </div>
                    </> : modalType == "delete" ? <>
                        <div className="headerModal">
                            <p className="pass-text">Delete Announcement Confirmation</p>
                            <button onClick={closeModal} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body">
                            <form >
                                <div className="pass-form-wrap" style={{ display: "flex", flexDirection: "row", justifyContent: "space-evenly" }}>
                                    <div className="login-button mt-2" style={{ width: "40%" }}>
                                        <button type="button" onClick={() => announcementDelete(id)} style={{ backgroundColor: "rgba(0, 69, 139,0.8)" }} className="cta-btn col-reds w-100">Delete</button>
                                    </div>
                                    <div className="login-button mt-2" style={{ width: "40%" }} >
                                        <button type="button" onClick={closeModal} style={{ backgroundColor: "rgba(0, 69, 139,0.8)" }} className="cta-btn col-reds w-100">Cancel</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </> : <></>}
                </div>
            </Modal>
            <div style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                marginTop: announcementListing ? "3%" : "12%"
            }}>
                <section className="coupon-sec-2">
                    <div className="container tableContainer">
                        <div className=" mt-2 mb-3 d-flex justify-content-end">
                            <button className="excel-btn col-reds w-10 pt-2 pb-2" style={{ backgroundColor: "#0077DC" }} onClick={() => viewModal(null, "create")} >Send Announcement
                            </button>
                        </div>
                    </div>
                </section>
                <section className="coupon-sec-2">
                    <div className="container tableContainer">
                        <div className="row">
                            <div className="col-12 col-md-12 col-lg-12">
                                <div className="card shadow mb-4">
                                    <div className="card-body">
                                        <div className="table-responsive" id="tableready">
                                            <table id="tableData" className="table table-bordered display" style={{ width: '100%', textAlign: "center" }}>
                                                <thead>
                                                    {announcementListing ? (<tr>
                                                        <th>S.No</th>
                                                        <th>Title</th>
                                                        <th>Detail</th>
                                                        <th>Action</th>
                                                    </tr>) : (<tr></tr>)}
                                                </thead>
                                                <tbody >
                                                    {announcementListing?.map((item, i) => (
                                                        <tr key={i}>
                                                            <td>{i + 1}</td>
                                                            <td>{item?.title}</td>
                                                            <td>
                                                                <span className="edit-icon" >
                                                                    <span style={{ cursor: "pointer", fontWeight: "bold", margin: 10, fontSize: 13, }} onClick={() => viewModal(item, "detail")}  ><i className="fas fa-eye"></i> View</span>
                                                                </span>
                                                            </td>
                                                            <td>
                                                                <span className="edit-icon" >
                                                                    {/* <span style={{ cursor: "pointer", fontWeight: "bold", margin: 10 }} onClick={() => viewModal(item, "edit")}  ><i className="fa fa-solid fa-edit"></i> Edit</span> */}
                                                                    <span style={{ cursor: "pointer", fontWeight: "bold", margin: 10 }} onClick={() => viewModal(item?._id, "delete")}  ><i className="fas fa-trash-alt"></i> Delete</span>
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    )
                                                    )}
                                                </tbody>
                                                {!announcementListing ?
                                                    status == "loading" || error ? <tfoot>
                                                        <tr><th>{status == "loading" ? "Loading..." : error ? error : ""}</th></tr>
                                                    </tfoot> : <></> : <></>}
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {modalImages && (
                    <ImageViewer
                        src={modalImages}
                        currentIndex={currentImage}
                        onClose={closeModal}
                        disableScroll={true}
                        backgroundStyle={{
                            backgroundColor: "rgba(0,0,0,0.9)",
                            zIndex: 3
                        }}
                        closeOnClickOutside={true}
                        showPrevButton={currentImage > 0}
                    />
                )}
            </div >
        </>
    )
}
export default Announcements
